module.exports = __webpack_public_path__ + "img/option-card-left-active-modal-icon.582f23cc.svg";